(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gg-landing-v2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.gg-lp-v2').forEach((root) => {
    if (root.dataset.enhanced === 'true') return;
    root.dataset.enhanced = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.classList.add('gg-lp-v2--enhanced');
    const targets = root.querySelectorAll('.gg-lp-v2__section, .gg-lp-v2__trust-strip');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('gg-lp-v2__visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    targets.forEach((target) => observer.observe(target));
  });

  } catch(e) { console.error(e); }
})();
})();
